export default __webpack_public_path__ + "static/media/icon_fechas_selected.ecfd5d4d.svg";